import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Tab, Tabs } from "react-bootstrap";
import paymentdone from "../assets/img/paymentdone.svg";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import ShippingRates from "./ShippingRates";
import Amount from "./Amount";
import { getEditQuotePay, payment, shippingCost } from "../api/api";
import axiosInstance from "../axios/axiosInstance";
import { toast } from "react-toastify";
import PaymentDone from "./Paymentdone";
import ShippingMethodSelector from "./ShippingMethodSelector";
import { trackEvent, trackException } from "../telemetry";
const CheckOutPay = ({
  show,
  loadingPayId,
  handleClose,
  address,
  shippingInfo,
  cardsData,
  handleShowCard,
}) => {
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isSameAsShipping, setIsSameAsShipping] = useState(false);
  const [selectedShippingAddress, setShippingSelectedAddress] = useState(null);
  const [handleCloseTrigger, sethandleCloseTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedCardPay, setSelectedCardPay] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedRate, setSelectedRate] = useState("");
  const [taxPercentage, setaxPercentage] = useState(0);
  const [taxAmount, settaxAmount] = useState(0);

  const formatPhoneNumber = (number) => {
    // Convert the input to a string
    const numberStr = String(number);

    // Remove non-numeric characters
    const cleaned = numberStr.replace(/\D/g, "");

    // Format based on length
    if (cleaned.length === 10) {
      // Format for a standard 10-digit phone number
      return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    } else if (cleaned.length === 11 && cleaned.startsWith("1")) {
      // Format for US-style 11-digit numbers with country code "1"
      return cleaned.replace(/(\d)(\d{3})(\d{3})(\d{4})/, "$1-$2-$3-$4");
    } else {
      // Generic fallback for other formats
      return cleaned;
    }
  };

  useEffect(() => {
    setSelectedAddress(null);
    setShippingSelectedAddress(null);
    setShippingSelectedAddress(null);
    setIsSameAsShipping(false);
    setActiveTab("card");
    setpoNumber("");
    setfileUpload("");
    setOrderReference("");
    setShowReferenceField(false);
    setaxPercentage(shippingInfo?.tax?.tax_percentage);
    settaxAmount(shippingInfo?.tax?.tax_amount);
  }, [show]);

  useEffect(() => {
    if (cardsData.length > 0) {
      const defaultCard = cardsData.find((card) => card.is_default === 1);
      setSelectedCard(defaultCard || null); // Set default card or null if not found
    }
  }, [cardsData]);
  const [modalShow, setModalShow] = useState(false);
  const [activeTab, setActiveTab] = useState("card"); // Set default active tab key

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const matchedRate = shippingInfo.shippingRates?.find(
    (rate) => rate.service_code === selectedRate
  );

  const deliveryDays = matchedRate?.delivery_days;
  useEffect(() => {
    if (handleCloseTrigger) {
      const timer = setTimeout(() => {
        navigate("/orders");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [handleCloseTrigger]);

  const [poNumberText, setpoNumber] = useState("");
  const [fileUpload, setfileUpload] = useState("");
  const [OrderReference, setOrderReference] = useState("");
  const [showReferenceField, setShowReferenceField] = useState(false);
  const handlePONumberChange = (e) => {
    const poNumber = e.target.value;
    // console.log("PO Number:", poNumber);
    setpoNumber(poNumber);
    // Perform any necessary state updates or validation here
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        alert("Please upload a valid PDF file.");
        return;
      }
      setfileUpload(file);
    }
  };

  const PaymentSubmit = async () => {
    let isValid = true;
    var po_number_type = "";
    var po_upload_type = "";
    if (isValid) {
      if (selectedRate === "") {
        toast.error("Please select a shipping method.");
        return;
      }
      if (activeTab == "card") {
        if (shippingInfo?.requestQuoteDB?.check_status == 0) {
          if (!selectedCardPay) {
            toast.error("Please select a payment card.");
            return;
          }
        }
      }
      if (activeTab == "net_terms") {
        if (poNumberText == "" && poNumberText.length < 1) {
          toast.error("Please add PO Number");
          return;
        }
        if (!fileUpload) {
          toast.error("Please upload a valid PDF file.");
          return;
        }
      }
      
      // Calculate total amount for tracking
      const totalAmount = parseFloat(shippingInfo?.requestQuoteDB?.total_amount || 0) +
        parseFloat(shippingInfo?.requestQuoteDB?.total_bend_price || 0) +
        parseFloat(rateVal === "" ? 0 : rateVal || 0) +
        parseFloat(taxAmount === "" ? 0 : taxAmount || 0);
      
      // Track payment started
      trackEvent('Payment_Started', {
        orderId: loadingPayId,
        amount: totalAmount,
        paymentMethod: activeTab,
        shippingMethod: selectedRate,
        isRFQ: shippingInfo?.requestQuoteDB?.check_status == 1,
        timestamp: new Date().toISOString()
      });
      
      const data_id = {
        id: loadingPayId,
        status: 1,
      };

      try {
        setLoading(true);
        const response_local = await axiosInstance.post(
          "/users/updateRequestQuoteRFQ",
          data_id
        );

        if (response_local.data.data.check_status == 1) {
          // Track RFQ submission
          trackEvent('RFQ_Submitted', {
            rfqId: loadingPayId,
            totalAmount: totalAmount,
            timestamp: new Date().toISOString()
          });
          
          localStorage.setItem("setItemelementData", "");
          localStorage.setItem("setItempartsDBdata", "");
          toast.success("Request quote sent successfully");
          setLoading(false);
          navigate("/rfqs");
        }
        if (response_local.data.data.check_status == 0) {
          var formData = new FormData();
          formData.append("id", loadingPayId);
          formData.append("po_number", poNumberText);
          formData.append("po_upload", fileUpload);
          formData.append("type", activeTab);
          formData.append("quote_type", 'quote');
          formData.append("card_token", selectedCardPay);
          if (OrderReference) {
            formData.append("order_reference", OrderReference);
          } 

          const res = await payment(formData);

          try {
            if (res.status == "success") {
              // Track successful payment
              trackEvent('Payment_Completed', {
                orderId: loadingPayId,
                amount: totalAmount,
                paymentMethod: activeTab,
                shippingMethod: selectedRate,
                timestamp: new Date().toISOString()
              });
              
              // Track order created
              trackEvent('Order_Created', {
                orderId: loadingPayId,
                totalValue: totalAmount,
                itemCount: shippingInfo?.requestQuoteDB?.total_quantity || 0,
                timestamp: new Date().toISOString()
              });
              
              setModalShow(true);
              setLoading(false);
              sethandleCloseTrigger(true);
              localStorage.removeItem("setItemelementData");
              localStorage.removeItem("setItempartsDBdata");
            } else {
              // Track payment failure
              trackEvent('Payment_Failed', {
                orderId: loadingPayId,
                amount: totalAmount,
                paymentMethod: activeTab,
                errorMessage: res.message,
                timestamp: new Date().toISOString()
              });
              
              toast.error(res.message);
              setLoading(false);
            }
          } catch (error) {
            // Track payment error
            trackEvent('Payment_Failed', {
              orderId: loadingPayId,
              amount: totalAmount,
              paymentMethod: activeTab,
              errorType: 'system_error',
              timestamp: new Date().toISOString()
            });
            trackException(error, { context: 'Payment_Processing' });
            
            setLoading(false);
            toast.error("Something went wrong.");
          }
        }
      } catch (error) {
        // Track checkout error
        trackEvent('Checkout_Error', {
          orderId: loadingPayId,
          errorMessage: error.message,
          timestamp: new Date().toISOString()
        });
        trackException(error, { context: 'Checkout_Submit' });
        
        setLoading(false);
        toast.error("Something went wrong.");
      }
    }
  };

  // Handle selection change
  const handleShippingAddressChange = (event) => {
    const selectedId = event.target.value;
    const selectedAddr = address.find((addr) => addr?._id === selectedId);
    setShippingSelectedAddress(selectedAddr || null);
    if (isSameAsShipping && selectedAddress) {
      setSelectedAddress(selectedAddr || null);
    }
  };

  const handleAddressChange = (event) => {
    const selectedId = event.target.value;
    const selectedAddr = address.find((addr) => addr?._id === selectedId);
    setSelectedAddress(selectedAddr || null);
  };
  const handleCheckboxChange = (event) => {
    setIsSameAsShipping(event.target.checked);
    if (event.target.checked) {
      const defaultShipping = address.find(
        (addr) => addr._id === selectedShippingAddress?._id
      );
      setSelectedAddress(defaultShipping || null);
    } else {
      setSelectedAddress(null);
    }
  };

  const [rateVal, setrateVal] = useState("");

  const handleRateSelected = async (rate, price) => {
    
    if (shippingInfo?.requestQuoteDB?.check_status == 1) {
      setrateVal(0);
      return;
    }
    setrateVal(price);
    setSelectedRate(rate);
    const elementId = localStorage.getItem("setItemelementData");

    const data = {
      service_code: rate,
      id: loadingPayId,
      address_id: selectedShippingAddress?._id,
      type: shippingInfo?.requestQuoteDB?.check_status == 1 ? "request" : "",
    };
    try {
      const res = await shippingCost(data);
      setaxPercentage(res?.data?.tax_percentage);
      settaxAmount(res?.data?.tax_amount);
    } catch (error) {}
  };

  // Helper function to find delivery days for a service code
  const findDeliveryDays = (serviceCode) => {
    return shippingInfo.shippingRates?.find(
      (rate) => rate.service_code === serviceCode
    )?.delivery_days || null;
  };

  // Build shipping methods array from quote data
  const buildShippingMethods = () => {
    const methods = [];
    const requestDB = shippingInfo?.requestQuoteDB;
    
    if (requestDB?.isSelected_ups_ground === 1) {
      methods.push({
        service_code: "ups_ground",
        service_type: "UPS Ground®",
        shipping_amount: requestDB.shipping_upsground_price,
        delivery_days: findDeliveryDays("ups_ground"),
      });
    }
    
    if (requestDB?.isSelected_ups_2nd_day_air === 1) {
      methods.push({
        service_code: "ups_2nd_day_air",
        service_type: "UPS 2nd Day Air®",
        shipping_amount: requestDB.shipping_ups_2nd_day_air_price,
        delivery_days: findDeliveryDays("ups_2nd_day_air"),
      });
    }
    
    if (requestDB?.isSelected_ups_next_day_air === 1) {
      methods.push({
        service_code: "ups_next_day_air",
        service_type: "UPS Next Day Air®",
        shipping_amount: requestDB.shipping_upsair_price,
        delivery_days: findDeliveryDays("ups_next_day_air"),
      });
    }
    
    return methods;
  };

  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="proceedCheckout_modal"
        size="lg"
      >
        <Modal.Body className="w-100">
          <div className="shipping_info">
            <Row>
              <Col lg={6}>
                {/* Shipping Address */}
                <div className="shipping_addr_name bill_addr_name">
                  <h2 className="shipping_head">Shipping Address</h2>

                  {/* {selectedShippingAddress ? ( */}
                  <Col xl={12} lg={12} md={12} className="mb-4">
                    <div className="addresses-grid">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h2 className="mb-0">
                          {
                            shippingInfo?.requestQuoteDB?.address_details
                              ?.full_name
                          }
                        </h2>
                      </div>
                      <p className="mb-2">
                        {
                          shippingInfo?.requestQuoteDB?.address_details
                            ?.nickname
                        }
                      </p>
                      <p className="mb-2">
                        {formatPhoneNumber(
                          shippingInfo?.requestQuoteDB?.address_details
                            ?.phone_number
                        )}
                      </p>
                      <p className="mb-3">
                        {
                          shippingInfo?.requestQuoteDB?.address_details
                            ?.address_line_1
                        }
                        , {shippingInfo?.requestQuoteDB?.address_details?.city}{" "}
                        {
                          shippingInfo?.requestQuoteDB?.address_details
                            ?.state_code
                        }
                        ,{" "}
                        {shippingInfo?.requestQuoteDB?.address_details?.pincode}
                        ,{" "}
                        {shippingInfo?.requestQuoteDB?.address_details?.country}
                      </p>
                      {/* <div className="btn-bottom">
                          
                        </div> */}
                    </div>
                  </Col>
                  {/* ) : (
                    !isSameAsShipping && (
                      <Col>
                        <p>No address selected</p>
                      </Col>
                    )
                  )} */}
                </div>
              </Col>
              <Col lg={6}>
                <div className="ship_methods mb-4"> 
                  <h2 className="shipping_head">Shipping Method</h2>
                  {shippingInfo?.requestQuoteDB?.shipping_price_update == 1 ? (
                    <div className="shippingbg_box">
                      <ShippingMethodSelector
                        shippingMethods={buildShippingMethods()}
                        selectedMethod={selectedRate}
                        onMethodChange={(code) => {
                          const requestDB = shippingInfo?.requestQuoteDB;
                          let price = 0;
                          
                          if (code === "local_pickup") price = 0.0;
                          else if (code === "custom_rates") price = requestDB?.custom_rates;
                          else if (code === "ups_ground") price = requestDB?.shipping_upsground_price;
                          else if (code === "ups_2nd_day_air") price = requestDB?.shipping_ups_2nd_day_air_price;
                          else if (code === "ups_next_day_air") price = requestDB?.shipping_upsair_price;
                          
                          handleRateSelected(code, price);
                        }}
                        showLocalPickup={shippingInfo?.requestQuoteDB?.isSelected_local_pickup === 1}
                        showTitle={false}
                        variant="checkout"
                        customFreight={{
                          show: shippingInfo?.requestQuoteDB?.isSelected_custom_shipping === 1,
                          rate: shippingInfo?.requestQuoteDB?.custom_rates,
                          label: "Freight Shipping"
                        }}
                      />
                    </div>
                  ) : (
                    <ShippingRates
                      shippingRates={shippingInfo.shippingRates}
                      divideWeight={shippingInfo.divideWeight}
                      onRateSelected={handleRateSelected}
                      RequestQuote={shippingInfo?.requestQuoteDB?.check_status}
                      selectedShippingAddress={111}
                      requestDb={shippingInfo?.requestQuoteDB}
                    />
                  )}
                </div>
              </Col>
              <Col lg={6}>
                {/* Billing Address */}
                <div className="bill_addr_name">
                  <h2 className="shipping_head">Billing Address</h2>

                  {/* Checkbox for "Same as Shipping Address" */}
                  {/* {selectedShippingAddress && (
                    <Form.Check
                      type="checkbox"
                      label="Same as Shipping Address"
                      checked={isSameAsShipping}
                      onChange={handleCheckboxChange}
                      className="mb-3"
                    />
                  )}

                  {!isSameAsShipping && (
                    <Form.Select
                      aria-label="Select Address"
                      onChange={handleAddressChange}
                      className="mb-3"
                    >
                      <option value="">Select Address</option>
                      {address.map((addr) => (
                        <option key={addr._id} value={addr._id}>
                          {addr.full_name} - {addr.address_line_1}, {addr.city}
                        </option>
                      ))}
                    </Form.Select>
                  )} */}
                  {/* {selectedAddress ? ( */}
                  <Col xl={12} lg={12} md={12} className="mb-4">
                    <div className="addresses-grid">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <h2 className="mb-0">
                          {
                            shippingInfo?.requestQuoteDB?.billing_details
                              ?.full_name
                          }
                        </h2>
                      </div>
                      <p className="mb-2">
                        {
                          shippingInfo?.requestQuoteDB?.billing_details
                            ?.nickname
                        }
                      </p>
                      <p className="mb-2">
                        {formatPhoneNumber(
                          shippingInfo?.requestQuoteDB?.billing_details
                            ?.phone_number
                        )}
                      </p>
                      <p className="mb-3">
                        {
                          shippingInfo?.requestQuoteDB?.billing_details
                            ?.address_line_1
                        }
                        , {shippingInfo?.requestQuoteDB?.billing_details?.city}{" "}
                        {
                          shippingInfo?.requestQuoteDB?.billing_details
                            ?.state_code
                        }
                        ,{" "}
                        {shippingInfo?.requestQuoteDB?.billing_details?.pincode}
                        ,{" "}
                        {shippingInfo?.requestQuoteDB?.billing_details?.country}
                      </p>
                    </div>
                  </Col>
                  {/* ) : (
                    !isSameAsShipping && (
                      <Col>
                        <p>No address selected</p>
                      </Col>
                    )
                  )} */}
                </div>
              </Col>
              <Col lg={6}>
                <div className="cards_sect paymentTab_div">
                  <div className="d-flex align-items-center justify-content-between mb-3 gap-2 flex-wrap">
                    <h2 className="shipping_head mb-0">Payment Method </h2>
                    <Button
                      onClick={handleShowCard}
                      variant={null}
                      className="btncustom btn-sm"
                    >
                      
                      Add Card<Icon
                        icon="mdi:add"
                        className="ms-1"
                        width={17}
                        height={17}
                      />
                    </Button>
                  </div>
                  {/* {shippingInfo?.requestQuoteDB?.} */}
                  <Tabs
                    defaultActiveKey="card"
                    id="uncontrolled-tab-example"
                    activeKey={activeTab}
                    onSelect={(key) => handleTabChange(key)}
                    className="mb-3"
                  >
                    <Tab eventKey="card" title="Card">
                      <div className="scroll_cards">
                        {shippingInfo?.requestQuoteDB?.check_status == 1 ? (
                          <>
                            <div className="text-center mt-2">
                              <b>
                                Once your RFQ has been approved you can proceed
                                with your payment.
                              </b>
                            </div>
                          </>
                        ) : cardsData.length === 0 ? (
                          <Col>
                            <p>No cards found</p>
                          </Col>
                        ) : (
                          cardsData.map((card, index) => (
                            <label
                              key={card.card_id || index}
                              className="paymentSelectCard"
                              htmlFor={`payment` + index}
                            >
                              <input
                                id={`payment` + index}
                                type="radio"
                                name="selectedCard"
                                value={card.card_id}
                                style={{ display: "none" }}
                                onChange={() =>
                                  setSelectedCardPay(card.card_id)
                                }
                              />
                                    {selectedCardPay === card.card_id ? (
                                                      <Icon icon="material-symbols:check-circle-rounded" color="#45a834" width={22} height={22}/>
                                                      ) : (
                                                      <Icon icon="material-symbols:circle-outline" color="#454545" width={22} height={22}/>
                                                      )}
                              <div className="paymentSelectbox">
                                <div className="card-info">
                                  {card.full_name.length > 10
                                    ? `${card.full_name
                                        .slice(0, 10)
                                        .toUpperCase()}..`
                                    : card.full_name.toUpperCase()}
                                </div>
                                <p>**** {card.last4}</p>
                                <div className="card-info">
                                  {card.exp_month}/{card.exp_year}
                                </div>
                              </div>
                            </label>
                          ))
                        )}
                      </div>
                      {shippingInfo?.requestQuoteDB?.check_status == 0 && (
                        <div className="mt-3">
                          <div className={`rate-option ${!showReferenceField ? 'mb-3' : ''}`}>
                            <label>
                              <input
                                type="checkbox"
                                checked={showReferenceField}
                                onChange={(e) => {
                                  setShowReferenceField(e.target.checked);
                                  if (!e.target.checked) {
                                    setOrderReference("");
                                  }
                                }}
                              />
                              <span style={{ fontSize: '0.9em', fontWeight: 'normal', opacity: 0.8 }}>&nbsp;&nbsp;Add Reference (Optional)</span>
                            </label>
                          </div>
                          {showReferenceField && (
                            <Form.Group className="mb-3 mt-2">
                              <Form.Control
                                type="text"
                                placeholder="Enter your order reference"
                                value={OrderReference}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value.length <= 200) {
                                    setOrderReference(value);
                                  }
                                }}
                                maxLength={200}
                              />
                              <Form.Text className="text-muted">
                                Add an order reference for your records
                              </Form.Text>
                            </Form.Group>
                          )}
                        </div>
                      )}
                    </Tab>
                    {shippingInfo?.requestQuoteDB?.pay_type == "1" && (
                      <Tab eventKey="net_terms" title="NET TERMS">
                        <div className="netTerms_flex">
                          <label htmlFor="poNumber">PO:</label>
                          <input
                            type="text"
                            id="poNumber"
                            name="poNumber"
                            min="1"
                            placeholder="Enter PO Number"
                            onChange={(e) => handlePONumberChange(e)}
                            style={{
                              margin: "10px 0",
                              width: "100%",
                            }}
                          />
                        </div>

                        <div className="POupload_field">
                          <label htmlFor="poUpload">
                            PO Upload (PDF only):
                          </label>
                          <input
                            type="file"
                            id="poUpload"
                            name="poUpload"
                            accept="application/pdf"
                            onChange={(e) => handleFileUpload(e)}
                            style={{
                              margin: "10px 0",
                              padding: "5px",
                              width: "100%",
                            }}
                          />
                        </div>
                        {shippingInfo?.requestQuoteDB?.check_status == 0 && (
                          <div className="mt-3">
                            <div className={`rate-option ${!showReferenceField ? 'mb-3' : ''}`}>
                              <label>
                                <input
                                  type="checkbox"
                                  checked={showReferenceField}
                                  onChange={(e) => {
                                    setShowReferenceField(e.target.checked);
                                    if (!e.target.checked) {
                                      setOrderReference("");
                                    }
                                  }}
                                />
                                <span style={{ fontSize: '0.9em', fontWeight: 'normal', opacity: 0.8 }}>&nbsp;&nbsp;Add Reference (Optional)</span>
                              </label>
                            </div>
                              {showReferenceField && (
                                <Form.Group className="mb-3 mt-2">
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter your order reference"
                                    value={OrderReference}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (value.length <= 200) {
                                        setOrderReference(value);
                                      }
                                    }}
                                    maxLength={200}
                                  />
                                <Form.Text className="text-muted">
                                  Add an order reference for your records
                                </Form.Text>
                                </Form.Group>
                              )}
                            </div>
                          )}
                        </Tab>
                    )}
                  </Tabs>
                </div>
              </Col>
            </Row>
            <div className="main_price text-center">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="quotesitem">Subtotal</span>
                <span className="quotesitem quotesright">
                  <Amount
                    amount={
                      shippingInfo?.requestQuoteDB?.total_amount +
                      parseFloat(shippingInfo?.requestQuoteDB?.total_bend_price)
                    }
                  />{" "}
                </span>
              </div>
              {/* <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="quotesitem">Services</span>
                <span className="quotesitem quotesright">
                  <Amount
                    amount={shippingInfo?.requestQuoteDB?.total_bend_price}
                  />{" "}
                </span>
              </div> */}
              {rateVal != "" ? (
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="quotesitem">Shipping</span>
                  <span className="quotesitem quotesright">
                    <Amount amount={rateVal || 0} />{" "}
                  </span>
                </div>
              ) : (
                ""
              )}
              {taxAmount != "" ? (
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="quotesitem">
                    Tax <b>({taxPercentage}%)</b>
                  </span>
                  <span className="quotesitem quotesright">
                    <Amount amount={taxAmount || 0} />{" "}
                  </span>
                </div>
              ) : (
                ""
              )}
              <div className="d-flex align-items-center justify-content-between">
                <span className="quotessubtotal">Total</span>
                <span className="quotesprice">
                  <Amount
                    amount={
                      parseFloat(
                        shippingInfo?.requestQuoteDB?.total_amount || 0
                      ) +
                      parseFloat(
                        shippingInfo?.requestQuoteDB?.total_bend_price || 0
                      ) +
                      parseFloat(rateVal == "" ? 0 : rateVal || 0) +
                      parseFloat(taxAmount == "" ? 0 : taxAmount || 0)
                    }
                  />
                </span>
              </div>
            </div>
            <div className="footer_btn">
              {shippingInfo?.requestQuoteDB?.check_status == 1 ? (
                <>
                  <Button
                    className="mt-3"
                    onClick={PaymentSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <>Request a Quote</>
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    className="mt-3"
                    onClick={PaymentSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <>
                        {activeTab == "card" ? (
                          <>
                            Proceed To Pay&nbsp;
                            <b>
                              <Amount
                                amount={
                                  parseFloat(
                                    shippingInfo?.requestQuoteDB
                                      ?.total_amount || 0
                                  ) +
                                  parseFloat(
                                    shippingInfo?.requestQuoteDB
                                      ?.total_bend_price || 0
                                  ) +
                                  parseFloat(rateVal == "" ? 0 : rateVal || 0) +
                                  parseFloat(
                                    taxAmount == "" ? 0 : taxAmount || 0
                                  )
                                }
                              />
                            </b>
                          </>
                        ) : (
                          "Pay With Net Terms"
                        )}
                      </>
                    )}
                    {/* </> */}
                    {/* )} */}
                  </Button>
                </>
              )}
              <Button
                className="mt-3"
                variant="lt-primary ms-2"
                onClick={handleClose}
              >
                {" "}
                Cancel
              </Button>
            </div>
          </div>
          <PaymentDone show={modalShow} handleClose={handleCloseTrigger} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default CheckOutPay;
